export default {
    getTopics: function() {
        return [
            {
                title: 'Roofing',
                to: '/roofing/home',
                icon: 'mdi-home-roof',
                image: require("@/assets/house-8.jpeg"),
                teaser: 'AquaDuct Roof and Gutters is one of the most experienced Colorado Springs and Denver roofing contractors. We’ve been replacing and repairing roofing in Colorado Springs for over 40 years, giving',
                text: 'AquaDuct Roof and Gutters is one of the most experienced Colorado Springs and Denver roofing contractors. We’ve been replacing and repairing roofing in Colorado Springs for over 40 years, giving our roofers the expertise necessary to handle any type of residential application. When you contact AquaDuct for assistance with your roofing project, count on our family-owned business to provide the kind of personal attention and care you can’t get from one of the big Denver roofing companies.'
            },
            {
                title: 'Gutters',
                to: '/gutters',
                icon: 'mdi-water-outline',
                image: require("@/assets/roof-7.jpeg"),
                teaser: 'For quality gutter installation, Denver homeowners turn to one of the few Denver roofing companies with gutters in its name: AquaDuct Roof and Gutters! Most folks don’t realize the importance',
                text: ''
            },
            {
                title: 'Windows',
                to: '/windows/energy',
                icon: 'mdi-window-closed-variant',
                image: require("@/assets/house-4.jpeg"),
                teaser: 'Few exterior improvements will freshen up the look of your Colorado Springs home like new vinyl siding and replacement windows. Replacing old siding with high-quality vinyl siding installed by the',
                text: ''
            },
            {
                title: 'Siding',
                to: '/siding/options',
                icon: 'mdi-shield-home-outline',
                image:  require("@/assets/house-7.jpeg"),
                teaser: 'Few exterior improvements will freshen up the look of your Colorado Springs home like new vinyl siding. Replacing old siding with high-quality vinyl siding installed by the pros at AquaDuct Roof and Gutters.',
                text: ''
            },
        ]
    }
}